var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningHighLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5509 13.4962L10.2694 1.07016C9.98947 0.592234 9.49789 0.353271 9.00631 0.353271C8.51473 0.353271 8.02315 0.592234 7.7125 1.07016L0.434388 13.4962C-0.0944022 14.4486 0.603402 15.6469 1.72615 15.6469H16.2892C17.4075 15.6469 18.1074 14.4521 17.5509 13.4962ZM2.06206 14.0083L8.97559 2.15573L15.9499 14.0083H2.06206ZM9.00631 10.7686C8.41368 10.7686 7.93303 11.2493 7.93303 11.8419C7.93303 12.4345 8.41471 12.9152 9.00768 12.9152C9.60065 12.9152 10.0796 12.4345 10.0796 11.8419C10.0782 11.25 9.6003 10.7686 9.00631 10.7686ZM8.18701 5.54217V8.81937C8.18701 9.2734 8.5557 9.63867 9.00631 9.63867C9.45693 9.63867 9.82561 9.27169 9.82561 8.81937V5.54217C9.82561 5.09156 9.46034 4.72287 9.00631 4.72287C8.55228 4.72287 8.18701 5.09156 8.18701 5.54217Z",
    fill: "#D48806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningHighLight);
export default __webpack_public_path__ + "static/media/WarningHighLight.c66fff3566f3bf6706dd1a071b1819d4.svg";
export { ForwardRef as ReactComponent };